import { render, staticRenderFns } from "./PriceTableCreateUpdate.vue?vue&type=template&id=9cf141f6&scoped=true&"
import script from "./PriceTableCreateUpdate.vue?vue&type=script&lang=js&"
export * from "./PriceTableCreateUpdate.vue?vue&type=script&lang=js&"
import style0 from "./PriceTableCreateUpdate.vue?vue&type=style&index=0&id=9cf141f6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9cf141f6",
  null
  
)

export default component.exports